// @dynamic-i18n-keys
//   studio.discountModal.form.appliesToCategoryInput.option.*
//   studio.discountModal.form.appliesToProductInput.option.*

export function getAppliesToBabelKeyNew(appliesToProduct: string): string {
  if (appliesToProduct === 'any_tier') {
    return 'studio.discountModal.form.appliesToCategoryInput.option.subscriptions';
  } else if (appliesToProduct) {
    return `studio.discountModal.form.appliesToProductInput.option.${appliesToProduct}`;
  }
  return '';
}
